import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { Observable } from "rxjs";
import { AuthService } from "./auth.service";
import { take, switchMap } from "rxjs/operators";

@Injectable({
  providedIn: "root"
})
export class AuthGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router,) {}

  canActivate(): Observable<boolean> | boolean {
    return this.auth.af.authState.pipe(
      take(1),
      switchMap(async authState => {
        if (authState) {
          // check are user is logged in
          const token = await authState.getIdTokenResult();
          if (
            token.claims.access_type == "LineLeapAdmin" ||
            token.claims.access_type == "VenueAdmin"
          ) {
            return true;
          } else {
            //Does not have the authorization for dashboard, revert to login.
            this.router.navigate(["/login"]);
            return false;
          }
        } else {
          this.router.navigate(["/login"]);
          return false;
        }
      })
    );
  }
}
